import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20organic%20flowing%20forms%20in%20soft%20cream%20and%20golden%20amber%20tones%2C%20minimalist%20health%20and%20wellness%20concept%2C%20gentle%20curves%20representing%20body%20and%20healing%2C%20clean%20medical%20but%20warm%20aesthetic%2C%20soft%20gradient%20lighting%2C%20no%20text%20or%20labels&width=1600&height=900&seq=hero-bladder-health&orientation=landscape"
          alt="膀胱健康知识科普"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/30"></div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-[720px]">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight">
            守护膀胱健康，<br className="hidden sm:block" />从科学认知开始
          </h1>
          <p className="text-sm md:text-lg text-white/85 max-w-[560px] mx-auto mb-6 md:mb-8 leading-relaxed">
            提供专业、科学的膀胱健康知识，帮助您了解泌尿系统保健、盆底肌训练和日常调理方法
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/bladder-health"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              开始学习
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 backdrop-blur-sm text-white rounded-full text-sm font-medium hover:bg-white/25 transition-colors duration-200 whitespace-nowrap cursor-pointer border border-white/20"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}